if (!customElements.get('jm-journal-tabs')) {
  customElements.define('jm-journal-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.nav = this.querySelector('.jm-journal__tabs');
      if (this.nav && this.tabs.length) {
        this.indicator = this.nav.querySelector('.jm-journal__indicator') || document.createElement('span');
        this.indicator.className = 'jm-journal__indicator';
        this.indicator.setAttribute('aria-hidden', 'true');
        this.nav.prepend(this.indicator);
        this.positionIndicator(false);
        this.resizeObserver = new ResizeObserver(() => this.positionIndicator(false));
        this.resizeObserver.observe(this.nav);
        this.tabs.forEach(tab => this.resizeObserver.observe(tab));
        const signal = this.controller.signal;
        document.fonts?.ready.then(() => {
          if (!signal.aborted) this.positionIndicator(false);
        });
      }
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (this.tabs.includes(tab)) this.select(tab);
      }, options);
      this.addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(event.target);
        if (index < 0) return;
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.select(this.tabs[next]);
        this.tabs[next].focus();
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        const tab = this.tabs.find(item => item.dataset.category === event.detail.blockId);
        if (tab) this.select(tab);
      }, options);
    }
    select(selected) {
      if (!this.tabs.includes(selected)) return;
      const previous = this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
      const next = this.tabs.indexOf(selected);
      if (previous === next) return;
      this.panelAnimation?.cancel();
      this.tabs.forEach(tab => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.category !== selected.dataset.category; });
      this.positionIndicator(true);
      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const activePanel = this.panels.find(panel => !panel.hidden);
      if (!reduceMotion && activePanel?.animate) {
        this.panelAnimation = activePanel.animate([
          { opacity: 0, transform: 'translate3d(' + (next > previous ? 24 : -24) + 'px,0,0)' },
          { opacity: 1, transform: 'translate3d(0,0,0)' }
        ], { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' });
      }
      if (this.nav && (selected.offsetLeft < this.nav.scrollLeft || selected.offsetLeft + selected.offsetWidth > this.nav.scrollLeft + this.nav.clientWidth)) {
        this.nav.scrollTo({ left: selected.offsetLeft - (this.nav.clientWidth - selected.offsetWidth) / 2, behavior: reduceMotion ? 'instant' : 'smooth' });
      }
    }
    positionIndicator(animate) {
      const selected = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true');
      if (!selected || !this.indicator || !selected.offsetWidth) return;
      this.indicator.style.transitionDuration = animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? '460ms' : '0ms';
      this.indicator.style.width = selected.offsetWidth + 'px';
      this.indicator.style.height = selected.offsetHeight + 'px';
      this.indicator.style.transform = 'translate3d(' + selected.offsetLeft + 'px,' + selected.offsetTop + 'px,0)';
      this.nav.classList.add('has-sliding-indicator');
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.panelAnimation?.cancel();
      this.controller = null;
    }
  });
}
